<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.secourspopulaire.fr/06/" target="_blank">
              A propos de nous
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/SecoursPop?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              target="_blank"
            >
              Twitter
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/secourspopulaire/"
              target="_blank"
            >
              Facebook
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/secourspop/?hl=fr"
              target="_blank"
            >
              Instagramm
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, made with <md-icon>favorite</md-icon> by
        <a href="https://server.ujpdsfl.cluster024.hosting.ovh.net/" target="_blank"
          >Secours populaire Français</a
        >
        Pour une meilleure gestion des bénévoles.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
